import { useCallback } from "react";
import { NavigateOptions, useSearchParams } from "react-router-dom";

export interface ISetSearchParamValueOptions {
  overrideParams?: { [key: string]: string };
  resetPage?: boolean;
  navigateOptions?: NavigateOptions;
}

export const useQueryParam = (
  key: string,
  options?: { defaultValue?: string },
): [
  string,
  (newValue: string | null, otherOptions?: ISetSearchParamValueOptions) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key) ?? options?.defaultValue ?? "";

  const setValue = useCallback(
    (newValue: string | null, otherOptions?: ISetSearchParamValueOptions) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (!newValue) {
        if (options?.defaultValue)
          newSearchParams.set(key, options.defaultValue);
        else newSearchParams.delete(key);
      } else {
        newSearchParams.set(key, newValue);
      }
      otherOptions?.resetPage && newSearchParams.set("page", "0");
      otherOptions?.overrideParams &&
        Object.entries(otherOptions.overrideParams).forEach(([key, value]) => {
          if (value) newSearchParams.set(key, value);
          else newSearchParams.delete(key);
        });
      setSearchParams(newSearchParams, otherOptions?.navigateOptions);
    },
    [key, searchParams, setSearchParams],
  );

  return [value, setValue];
};
